module.exports = __webpack_public_path__ + "img/telephone.f5996635.svg";